//export const ServerBaseUrlForStaticImages = "http://127.0.0.1:5000/";
// export const ServerBaseUrlForStaticImages = "https://justclickindia.co.in/service_dce_test/";
export const ServerBaseUrlForStaticImages = "https://justclickindia.co.in/develop_api/";
//export const ServerBaseUrlForStaticImages = "https://justclickindia.co.in/service_dev_api/"


export const fileUploadInputStyle = {
    display: "none",
}


export const fileUploadLableStyle = {
    // "background-color": "#49a3f1",
    color: "#495057",
    "background-color": "transparent",
    border: "1px solid #495057",
    "border-radius": "4px",
    padding: "12px 10px ",
}
